const apiConfig = {
   API: 'https://jsonplaceholder.typicode.com',
   USERS: 'users',
};

export default apiConfig;
